// File: src/theme/components.ts
// Define component-specific theme overrides

const components = {
  Button: {
    baseStyle: {
      fontWeight: 'medium',
      borderRadius: 'md',
    },
    variants: {
      primary: {
        bg: 'brand.primary.base',
        color: 'white',
        _hover: {
          bg: 'brand.primary.light',
        },
      },
      secondary: {
        bg: 'brand.secondary.base',
        color: 'white',
        _hover: {
          bg: 'brand.primary.dark',
        },
      },
      outline: {
        borderColor: 'brand.primary.base',
        color: 'brand.primary.base',
      },
    },
    defaultProps: {
      variant: 'primary',
    },
  },
  Heading: {
    baseStyle: {
      fontWeight: 'bold',
    },
  },
  Card: {
    baseStyle: {
      p: 6,
      borderRadius: 'lg',
      boxShadow: 'md',
    },
  },
};

export default components;